import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  getAllFormConditions: [],
  forms: null, //Kept as null to be handled in add form conditions page
  getFormConditionById: {},
  getFormCondition: {},
};

const formConditionsSlice = createSlice({
  name: 'formConditionsSlice',
  initialState,
  reducers: {
    getAllFormConditionsSlice: (state, { payload }) => {
      state.getAllFormConditions = payload;
    },
    getAllFormsSlice: (state, { payload }) => {
      state.forms = payload;
    },
    getFormConditionByIdSlice: (state, { payload }) => {
      state.getFormConditionById = payload;
    },
    getFormConditionSlice: (state, { payload }) => {
      state.getFormCondition = payload;
    },
  },
});

const { actions, reducer } = formConditionsSlice;

export const {
  getAllFormConditionsSlice,
  getAllFormsSlice,
  getFormConditionByIdSlice,
  getFormConditionSlice,
} = actions;

export default reducer;
